import { useState, useCallback } from 'react';
import moment from 'moment';
import { reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { zones } from 'services/zones';
import { Container, ButtonsContainer, Multiselect, ZoneInput, DateTime, required } from 'libs/form';
import { Button, themes } from 'libs/ui';
import { api } from 'api';
import { Buttons, Confirm, Title, UpdateMessageBox } from './parkings-filter.styled';

const FilterForm = (props) => {
  const { t } = useTranslation();
  const requiredT = useCallback(required(t), [t]);

  const [data, setData] = useState(undefined);
  const [confirm, setConfirm] = useState(false);
  const [result, setResult] = useState(false);

  const showMessage = () => {
    setResult(true);
    setTimeout(() => {
      setResult(false);
    }, 3000);
  };

  const action = () => {
    const d = data.end_at.toISOString();

    api.call('stays.auto_close', { max_entry_at: d, zones: data.zones }).then(() => {
      setConfirm(false);
      showMessage();
    });
  };

  const closeConfirm = () => {
    setConfirm(false);
  };

  const showConfirm = (formData) => {
    setData(formData);
    setConfirm(true);
  };

  const zonesItems = zones.getZones();
  const d = data ? moment(data.end_at).format('ll') : '';
  const zonesList = data ? data.zones.join(', ') : '';

  const valid = true;

  return (
    <Container className="hide-cal-icon">
      {result && <UpdateMessageBox>{t('filter.Парковки завершены')}</UpdateMessageBox>}
      {confirm ? (
        <Confirm>
          <Title>
            {t('filter.Все активные парковки с датой начала (въездом) до') + ' ' + '0:00' + ' '}
            {d}
            {t('filter.для выбранных парковочных зон') + ' '}({zonesList}) {t('filter.будут завершены. Подтвердить?')}
          </Title>
          <Buttons>
            <Button theme={themes.blue} onClick={closeConfirm}>
              {t('buttons.Отменить')}
            </Button>
            <Button theme={themes.red} onClick={action}>
              {t('buttons.Завершить')}
            </Button>
          </Buttons>
        </Confirm>
      ) : (
        <form onSubmit={props.handleSubmit(showConfirm)}>
          <DateTime width="215px" name="end_at" type="date" label={t('filter.Завершить все парковки до')} validate={requiredT} />

          <Multiselect
            width="160px"
            name="zones"
            type="multiselect"
            label={t('sections.Зоны')}
            additionalComponent={ZoneInput}
            data={zonesItems}
            countDisplayedIcons={3}
            simpleErrorWrapper
            validate={requiredT}
          />

          <ButtonsContainer>
            <Button disabled={!valid} type="submit" theme={themes.blue}>
              {t('buttons.Завершить')}
            </Button>
          </ButtonsContainer>
        </form>
      )}
    </Container>
  );
};

export const Filter = reduxForm({
  form: 'parkingsFilter',
  // destroyOnUnmount: false,
})(FilterForm);
